/**
 * Date utility functions for event validation
 */

/**
 * Get today's date in YYYY-MM-DD format (local timezone)
 * @returns Today's date as a string in YYYY-MM-DD format
 */
export const getTodayDateString = (): string => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Check if a date string represents a past date (before today)
 * @param dateString Date string in YYYY-MM-DD format
 * @returns true if the date is in the past, false if today or future
 */
export const isPastDate = (dateString: string): boolean => {
  if (!dateString) return false;
  
  const inputDate = new Date(dateString + 'T00:00:00'); // Ensure local timezone
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Set to start of today for fair comparison
  
  return inputDate < today;
};

/**
 * Validate that an event date is not in the past
 * @param dateString Date string in YYYY-MM-DD format
 * @returns Error message if invalid, null if valid
 */
export const validateEventDate = (dateString: string): string | null => {
  if (!dateString) {
    return 'Event date is required';
  }
  
  if (isPastDate(dateString)) {
    const todayString = getTodayDateString();
    return `Events can only be created for future dates. Today is ${todayString}.`;
  }
  
  return null;
};